module.exports = __webpack_public_path__ + "static/media/manifestIcon.0d4326ea.svg";